import { useEffect, useMemo } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { AppErrorFallback, createErrorReport } from './app-error-boundary';

export function AppRouteError({ embedded = false }: { embedded?: boolean }) {
  const error = useRouteError();
  const report = useMemo(() => createErrorReport(normalizeRouteError(error), 'content'), [error]);

  useEffect(() => {
    console.error('Application route error', { error, reference: report.reference });
  }, [error, report.reference]);

  return <AppErrorFallback report={report} variant={embedded ? 'content' : 'page'} onRetry={() => window.location.reload()} />;
}

export function routeErrorMessage(error: unknown) {
  if (isRouteErrorResponse(error)) return error.statusText || `Error ${error.status}`;
  if (error instanceof Error) return error.message;
  return 'Ocurrio un error inesperado.';
}

function normalizeRouteError(error: unknown) {
  if (error instanceof Error) return error;
  return new Error(routeErrorMessage(error));
}
